export const contexts = {
  login: 'login',
  members: 'members',
  memberProfile: 'memberProfile',
  notFound: 'notFound',
};

export const contextToPageNameMap = {};
